import { useState } from 'react'

import orderBy from 'lodash/orderBy'

import { SortDirection } from '../types'

export function useSort<T>(
  data: T[],
  columns: (keyof T)[],
  dispatchNewReorder: (data: (keyof T)[]) => void,
  initialSort?: {
    orderBy?: keyof T | null
    direction?: SortDirection
  },
) {
  const [sortingColumn, setSortingColumn] = useState<keyof T | null>(initialSort?.orderBy || null)
  const [sortingDirection, setSortingDirection] = useState<SortDirection>(
    initialSort?.direction || SortDirection.asc,
  )

  const handleSort = (column: keyof T) => {
    if (sortingColumn === column) {
      setSortingDirection(
        sortingDirection === SortDirection.asc ? SortDirection.desc : SortDirection.asc,
      )
    } else {
      setSortingColumn(column)
      setSortingDirection(SortDirection.asc)
    }
  }

  const getSortedTrades = (data: T[]) => {
    if (!sortingColumn) {
      return data
    }

    const formattedData = data.map((trade) => {
      const columnValue = trade[sortingColumn]
      const formattedValue =
        !isNaN(Number(columnValue)) && columnValue !== null ? Number(columnValue) : columnValue
      return { ...trade, [sortingColumn]: formattedValue }
    })

    return orderBy(
      formattedData,
      [sortingColumn],
      [sortingDirection === SortDirection.asc ? 'asc' : 'desc'],
    )
  }

  const sortedTrades = getSortedTrades(data)

  const handleColumnReorder = (startIndex: number, endIndex: number) => {
    const newColumnOrder = Array.from(columns)
    const [removed] = newColumnOrder.splice(startIndex, 1)
    newColumnOrder.splice(endIndex, 0, removed)
    dispatchNewReorder(newColumnOrder)
  }

  return { handleSort, sortedTrades, sortingColumn, sortingDirection, handleColumnReorder }
}
